import { SHStack } from "@components/design-systems";
import { useTheme } from "@mui/material";
import { MSFilterLabelSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/label";
import SHSkeleton from "@components/design-systems/sh-skeleton";

export const MSFilterSwitchDropDownSkeleton = () => {
  const { palette, shadows } = useTheme();

  return (
    <SHStack
      padding={1.5}
      bgcolor={palette.common.white}
      borderRadius={"12px"}
      boxShadow={shadows[1]}
      gap={1.5}
    >
      <MSFilterLabelSkeleton />
      <SHSkeleton width={"100%"} height={40} delay={false} />

      <MSFilterLabelSkeleton showIcon={false} />
      <SHSkeleton width={"100%"} height={40} delay={false} />
    </SHStack>
  );
};
